// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M12.8145 3C12.6109 3.63014 12.5 4.30209 12.5 5C12.5 8.58985 15.4101 11.5 19 11.5C20.5091 11.5 21.8968 10.984 23 10.1211V21H1V3H12.8145ZM12 17H19V15H12V17ZM4.91602 9.66895L7.24414 12L4.91602 14.3311L6.33105 15.7441L10.0703 12L6.33105 8.25586L4.91602 9.66895Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M20.4551 3.54395L23.6797 5L20.4551 6.45508L19 9.67969L17.5439 6.45508L14.3203 5L17.5439 3.54395L19 0.320312L20.4551 3.54395Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-ai-terminal-filled')
export default class AiTerminalFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'ai-terminal-filled',
    }
  }
}
